import { render } from "./S106758.vue?vue&type=template&id=1239e810"
const script = {}
script.render = render

export default script